import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { revokeEntitlements } from 'api/admin/businesses/entitlements';
import { ApiError } from 'types/api';
import { RevokeEntitlementsPayload } from 'types/entitlements/entitlements';

interface RevokeEntitlementsOptions {
  successCallback?: () => void;
}

export const useRevokeEntitlements = ({ successCallback }: RevokeEntitlementsOptions = {}) => {
  return useMutation<unknown, ApiError, RevokeEntitlementsPayload>({
    mutationFn: async (payload) => {
      await revokeEntitlements(payload);
    },
    onSuccess: () => {
      successCallback?.();
      toast.success('Entitlements revoked', { duration: 4000 });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? 'An error occurred while revoking entitlements', {
        duration: 4000,
      });
    },
  });
};
